/**
 * Represente les points d'entrée (socket input) d'un noeud affichant une étape de workflow.
 */
export class StepInput {
    /**
     * Code de la socket.
     */
    public code: number;

    /**
     * Libellé de la socket
     */
    public label: string;

    /**
     * Constructeur.
     * @param actionId : Id de l'action.
     */
    constructor(public actionId: number) {}
}
